"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _useAutoclose.default;
  }
});
var _useAutoclose = _interopRequireDefault(require("./useAutoclose"));
//# sourceMappingURL=index.js.map